/* eslint-disable global-require */
const taps = {
  sfx_tap: require('./sfx_hub_global_tap.mp3'),
  sfx_soft_tap: require('./sfx_hub_global_ui_tap.mp3'),
};
export default taps;
